import { useState, useEffect } from "react";
import { toast } from "sonner";
import { conciergeApi } from "@/components/concierge/api";
import { CommissionTable } from "@/components/concierge/CommissionTable";
import { downloadCommissionPdf } from "@/components/concierge/commissionPdf";

export const CommissionSection = () => {
  const [data, setData] = useState(null);
  const [name, setName] = useState("L'Étoile Part-Dieu");

  useEffect(() => {
    conciergeApi.get("/commissions").then((r) => setData(r.data));
    conciergeApi.get("/me").then((r) => setName(r.data.name));
  }, []);

  const onPdf = async (row, isCurrent) => {
    try {
      const res = await conciergeApi.get("/deposits");
      downloadCommissionPdf({ row, rate: data.rate, deposits: res.data, conciergeName: name, isCurrent });
    } catch (error) {
      toast.error("Impossible de générer le PDF");
    }
  };

  return (
    <div className="space-y-3" data-testid="concierge-commission-section">
      <p className="text-sm text-slate-600">Votre part : <strong>25 %</strong> du montant facturé aux clients pro, calculée le 1er de chaque mois pour le mois précédent.</p>
      <CommissionTable data={data} onPdf={onPdf} />
    </div>
  );
};
